import { AppColors } from "@/assets/colors";
import { AppLinks, pxToRem } from "@/util";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";

export default function OwnProperty() {
  const { classes } = styles();
  return (
    <Box className={`${classes.container}`}>
      <Typography className={`${classes.own}`}>Own a property</Typography>
      <Typography className={`${classes.unlock}`}>
        Unlock Your Dream Home Today!
      </Typography>
      <Typography className={`${classes.gain}`}>
        Gain Exclusive Access to Premium Listings, Real-Time Updates,and <br />{" "}
        Personalized Property Recommendations!
      </Typography>
      <Box className={`${classes.btnCont}`}>
        <Button
          className={`${classes.btn} ${classes.viewBtn}`}
          href={AppLinks.PUBLIC.LISTINGS}
        >
          View Available Properties
        </Button>
        <Button
          className={`${classes.btn} ${classes.startBtn}`}
          href={AppLinks.PUBLIC.LISTINGS}
        >
          Start Investing Today
        </Button>
      </Box>
      <Typography className={classes.join}>
        Join{" "}
        <Typography color="primary" className={classes.joinSpan}>
          100+
        </Typography>{" "}
        other Clients that invest with us
      </Typography>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    minHeight: pxToRem(400),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    backgroundColor: AppColors.neutral["82"],
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  debug: {
    border: "1px solid red",
  },
  own: {
    fontFamily: "Playfair Display",
    fontWeight: 500,
    fontSize: pxToRem(24),
    color: AppColors.text.default,
  },
  unlock: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(38),
  },
  gain: {
    fontWeight: 400,
    fontSize: pxToRem(16),
    color: AppColors.text.default,
    textAlign: "center",
    opacity: 0.5,
    marginBottom: theme.spacing(3),
  },
  join: {
    textAlign: "center",
    display: "flex",
    gap: theme.spacing(2),
    fontWeight: 500,
    fontSize: pxToRem(14),
    color: "#9EA3AE",
    marginTop: theme.spacing(4),
  },
  btnCont: {
    display: "flex",
    gap: theme.spacing(3),
  },
  btn: {
    height: pxToRem(40),
    fontWeight: 500,
    fontSize: pxToRem(16),
  },
  viewBtn: {
    color: "#262626",
    backgroundColor: theme.colors.white,
    fontSize: pxToRem(14),
    padding: theme.spacing(3),
    borderRadius: pxToRem(8),
  },
  joinSpan: {
    fontSize: pxToRem(14),
  },
  startBtn: {
    backgroundColor: AppColors.primary["400"],
    color: theme.colors.white,
    fontSize: pxToRem(14),
    fontWeight: 500,
    padding: theme.spacing(3),
    borderRadius: pxToRem(8),
  },
}));
